<template>
    <div :class="cellClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            width: { type: String, default: undefined },
            isDisabled: { type: Boolean, default: false },
        },

        computed: {
            cellClass() {
                return {
                    'form-cell': true,
                    'form-cell--is-disabled': this.isDisabled,
                    [`form-cell--width-${this.width}`]: this.width,
                }
            },
        },
    }
</script>
